// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  emotionId: __t.u64().primaryKey().name("emotion_id"),
  versonaId: __t.u64().name("versona_id"),
  worldId: __t.u64().name("world_id"),
  etype: __t.string(),
  targetId: __t.u64().name("target_id"),
  causeRef: __t.u64().name("cause_ref"),
  causeText: __t.string().name("cause_text"),
  intensity: __t.u32(),
  halfLifeS: __t.u32().name("half_life_s"),
  attendantOf: __t.u64().name("attendant_of"),
  elicitedAt: __t.timestamp().name("elicited_at"),
});
